
export const ELCOVIA_LOGO = process.env.PUBLIC_URL + "/logo.png";
export const ELCOVIA_FAVICON = process.env.PUBLIC_URL + "/favicon.ico";
export const ELCOVIA_OPEN_GRAPH = process.env.PUBLIC_URL + "/social-media/elcovia_open_graph.png";
export const ELCOVIA_TWITTER_CARD = process.env.PUBLIC_URL + "/social-media/elcovia_twitter.png";
